"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _formatVodData2 = require("../../utils/formatVodData");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  BuyProduct2 = _require.BuyProduct2;
const formatBuyProduct = (properties, options = {}) => {
  const modTitle = properties.modTitle,
    color = properties.color,
    backgroundImage = properties.backgroundImage,
    _properties$buyProduc = properties.buyProductList,
    buyProductList = _properties$buyProduc === void 0 ? [] : _properties$buyProduc,
    _properties$porintId = properties.porintId,
    porintId = _properties$porintId === void 0 ? '' : _properties$porintId,
    _properties$mergeComp = properties.mergeComponentStatus,
    mergeComponentStatus = _properties$mergeComp === void 0 ? false : _properties$mergeComp,
    _properties$paddingTo = properties.paddingTopNum,
    paddingTopNum = _properties$paddingTo === void 0 ? '' : _properties$paddingTo,
    _properties$paddingBo = properties.paddingBottomNum,
    paddingBottomNum = _properties$paddingBo === void 0 ? '' : _properties$paddingBo; // 第一条数据是模块名称
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const configuration = buyProductList.map((productItem, index) => {
    const _productItem$product = productItem.product1Title,
      product1Title = _productItem$product === void 0 ? '' : _productItem$product,
      _productItem$product2 = productItem.product1Duration,
      product1Duration = _productItem$product2 === void 0 ? '' : _productItem$product2,
      _productItem$product3 = productItem.product1Content,
      product1Content = _productItem$product3 === void 0 ? '' : _productItem$product3,
      _productItem$product4 = productItem.product1BtnTxt,
      product1BtnTxt = _productItem$product4 === void 0 ? '' : _productItem$product4,
      _productItem$product5 = productItem.product1BtnHref,
      product1BtnHrefBase = _productItem$product5 === void 0 ? '' : _productItem$product5,
      _productItem$productL = productItem.productList,
      productList = _productItem$productL === void 0 ? [] : _productItem$productL,
      _productItem$product6 = productItem.product1BgType,
      product1BgType = _productItem$product6 === void 0 ? 'https://staticintl.cloudcachetci.com/cms/backend-cms/VeCP394_essential.png' : _productItem$product6,
      _productItem$commodit = productItem.commodityObject,
      commodityObject = _productItem$commodit === void 0 ? '{}' : _productItem$commodit;
    const product1BtnHref = formatUrlString(product1BtnHrefBase);
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const resultList = productList.map(productItem => {
      const _productItem$sonTitle = productItem.sonTitle,
        sonTitle = _productItem$sonTitle === void 0 ? '' : _productItem$sonTitle,
        _productItem$sonText = productItem.sonText,
        sonText = _productItem$sonText === void 0 ? '' : _productItem$sonText;
      return {
        title: sonTitle,
        text: sonText
      };
    });
    return _objectSpread(_objectSpread({
      title: product1Title,
      duration: product1Duration,
      content: formatUrlInText(product1Content),
      but_txt: product1BtnTxt,
      but_href: product1BtnHref,
      text_list: resultList,
      backgroundUrl: product1BgType
    }, resultCommodityObject), {}, {
      extendProps: {
        'report-event-goal': 'click_buy_product_2',
        'report-event': 'click_buy_product_2_button',
        'report-ext1': index,
        'report-ext2': product1BtnTxt,
        'report-ext3': product1BtnHref
      }
    });
  });
  return {
    modTitle,
    configuration,
    bgColor: color,
    backgroundImage,
    porintId,
    mergeComponentStatus,
    paddingTopNum,
    paddingBottomNum
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatBuyProduct = formatBuyProduct(data, {
        domains
      }),
      modTitle = _formatBuyProduct.modTitle,
      configuration = _formatBuyProduct.configuration,
      bgColor = _formatBuyProduct.bgColor,
      backgroundImage = _formatBuyProduct.backgroundImage,
      porintId = _formatBuyProduct.porintId,
      mergeComponentStatus = _formatBuyProduct.mergeComponentStatus,
      paddingTopNum = _formatBuyProduct.paddingTopNum,
      paddingBottomNum = _formatBuyProduct.paddingBottomNum;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    const _formatVodData = (0, _formatVodData2.formatVodData)(backgroundImage),
      url = _formatVodData.url;
    if (url) {
      bgStyle['backgroundImage'] = `url(${url})`;
      bgStyle['backgroundSize'] = 'cover';
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId || modTitle
    }, (0, _reportUtil.reportShow)(['show_buyProduct2', componentKey, modTitle])), /*#__PURE__*/React.createElement(BuyProduct2, {
      flexTitle: modTitle,
      mergeComponentStatus: mergeComponentStatus,
      paddingTopNum: paddingTopNum,
      paddingBottomNum: paddingBottomNum,
      configuration: configuration,
      style: bgStyle,
      onCallback: item => {
        window.asyncReceiveCommodity(item);
      }
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}